/***
 * the enum for the scholarship
 */

export const Scholarship = {
    scholarship: "יש מילגה",
    no:"אין מילגה",
}